// GENERATED by scripts/gen-hooks.mjs. Do not edit by hand.
// 17 hooks for backend/tasks.

import { useBackend } from '../useBackend'

/** POST /api/tasks/addTaskUpdate */
export function useAddTaskUpdate<T = any>() {
  return useBackend<T>('tasks/addTaskUpdate')
}

/** POST /api/tasks/createTask */
export function useCreateTask<T = any>() {
  return useBackend<T>('tasks/createTask')
}

/** POST /api/tasks/decideTargetDateChange */
export function useDecideTargetDateChange<T = any>() {
  return useBackend<T>('tasks/decideTargetDateChange')
}

/** POST /api/tasks/getTaskAssetUrl */
export function useGetTaskAssetUrl<T = any>() {
  return useBackend<T>('tasks/getTaskAssetUrl')
}

/** POST /api/tasks/getTaskBoard */
export function useGetTaskBoard<T = any>() {
  return useBackend<T>('tasks/getTaskBoard')
}

/** POST /api/tasks/getTaskDetail */
export function useGetTaskDetail<T = any>() {
  return useBackend<T>('tasks/getTaskDetail')
}

/** POST /api/tasks/getTaskIngestRuns */
export function useGetTaskIngestRuns<T = any>() {
  return useBackend<T>('tasks/getTaskIngestRuns')
}

/** POST /api/tasks/getTaskLinkOptions */
export function useGetTaskLinkOptions<T = any>() {
  return useBackend<T>('tasks/getTaskLinkOptions')
}

/** POST /api/tasks/getTaskParentOptions */
export function useGetTaskParentOptions<T = any>() {
  return useBackend<T>('tasks/getTaskParentOptions')
}

/** POST /api/tasks/getTaskPeople */
export function useGetTaskPeople<T = any>() {
  return useBackend<T>('tasks/getTaskPeople')
}

/** POST /api/tasks/recordTaskAsset */
export function useRecordTaskAsset<T = any>() {
  return useBackend<T>('tasks/recordTaskAsset')
}

/** POST /api/tasks/requestTargetDateChange */
export function useRequestTargetDateChange<T = any>() {
  return useBackend<T>('tasks/requestTargetDateChange')
}

/** POST /api/tasks/resolveTaskRef */
export function useResolveTaskRef<T = any>() {
  return useBackend<T>('tasks/resolveTaskRef')
}

/** POST /api/tasks/setTaskLinks */
export function useSetTaskLinks<T = any>() {
  return useBackend<T>('tasks/setTaskLinks')
}

/** POST /api/tasks/signTaskUpload */
export function useSignTaskUpload<T = any>() {
  return useBackend<T>('tasks/signTaskUpload')
}

/** POST /api/tasks/undoTaskIngest */
export function useUndoTaskIngest<T = any>() {
  return useBackend<T>('tasks/undoTaskIngest')
}

/** POST /api/tasks/updateTask */
export function useUpdateTask<T = any>() {
  return useBackend<T>('tasks/updateTask')
}
